import React from 'react';

const About = () => {
  const features = [
    {
      icon: 'fas fa-shield-alt',
      title: 'Secure & Scalable',
      subtitle: 'Built-in automation'
    },
    {
      icon: 'fas fa-users',
      title: 'Trusted Partners',
      subtitle: 'Global network'
    },
    {
      icon: 'fas fa-cube',
      title: 'Product-Focused',
      subtitle: 'Not consulting-driven'
    },
    {
      icon: 'fas fa-rocket',
      title: 'Modern Solutions',
      subtitle: 'API-first design'
    }
  ];

  return (
    <section id="about" className="py-5 bg-light">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mx-auto text-center mb-5">
            <h2 className="display-5 fw-bold mb-4">Vision and Mission</h2>
            <div className="row g-4">
              <div className="col-md-6">
                <div className="bg-white p-4 rounded shadow-sm h-100">
                  <h4 className="fw-bold text-primary mb-3">Vision</h4>
                  <p className="text-muted">
                    To create efficient, secure, and scalable digital tools that solve real-world problems through smart, minimal operations.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="bg-white p-4 rounded shadow-sm h-100">
                  <h4 className="fw-bold text-primary mb-3">Mission</h4>
                  <p className="text-muted">
                    To build and maintain high-quality software products using a remote-first, partner-driven model without the overhead of traditional corporate structures.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row g-4">
          {features.map((feature, index) => (
            <div key={index} className="col-md-6 col-lg-3">
              <div className="text-center">
                <div className="mb-3">
                  <i className={`${feature.icon} fa-3x text-primary`}></i>
                </div>
                <h6 className="fw-bold">{feature.title}</h6>
                <small className="text-muted">{feature.subtitle}</small>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;

